






import { Component, Vue } from "vue-property-decorator";
import Index from "./components/Index.vue";
import "es6-promise";
import "isomorphic-fetch";

@Component({
  components: {
    Index
  }
})
export default class App extends Vue {}
